import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useUpdateCustomer = () => {
  const queryClient = useQueryClient();

  return apiClient.customer.updateCustomer.useMutation({
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customer', variables.params.id] });
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      toast.success('Customer saved successfully!');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Error saving the customer!');
    },
  });
};
